import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';
import { useTranslation } from 'react-i18next';
import { SafeHtml } from '@websky/core/src/__fsd__/shared/ui';

const WarningDescription: EngineRenderers['renderWarningDescription'] = () => {
	const { t } = useTranslation('FareLock');

	return (
		<SafeHtml tag="span" html={t('Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!')} />
	);
};
export default WarningDescription;
